// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.33.2
// source: api/devplan/types/usage.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "../../../google/protobuf/timestamp";
import { TokensUsage } from "./common";
import { AgentType, agentTypeFromJSON, agentTypeToJSON } from "./threads";

export const protobufPackage = "api.devplan.types.usage";

export enum AppUsageType {
  UNKNOWN_USAGE = 0,
  CREATE_PROJECT = 1,
  CREATE_DOCUMENT = 2,
  INVITE_USER = 3,
  SEND_CHAT_MESSAGE = 4,
  CREATE_COMPANY = 5,
  CREATE_IDEA = 6,
  REPOSITORY_ANALYSIS = 7,
  REPOSITORY_RESCAN = 8,
  SITE_RESCAN = 9,
  PROMPTS_DOWNLOADS = 10,
  LINEAR_SYNC = 11,
  VIEW_CODING_PROMPTS = 12,
  REGENERATE_FEATURES = 13,
  PULSE_ENROLLMENT = 14,
  CODE_RESEARCH_ENROLLMENT = 15,
  JIRA_SYNC = 16,
  BITBUCKET_SYNC = 17,
  PROJECT_SIMULATION = 18,
  ROADMAP_VIEW = 19,
  RUN_BUTTON_RUNS = 20,
}

export function appUsageTypeFromJSON(object: any): AppUsageType {
  switch (object) {
    case 0:
    case "UNKNOWN_USAGE":
      return AppUsageType.UNKNOWN_USAGE;
    case 1:
    case "CREATE_PROJECT":
      return AppUsageType.CREATE_PROJECT;
    case 2:
    case "CREATE_DOCUMENT":
      return AppUsageType.CREATE_DOCUMENT;
    case 3:
    case "INVITE_USER":
      return AppUsageType.INVITE_USER;
    case 4:
    case "SEND_CHAT_MESSAGE":
      return AppUsageType.SEND_CHAT_MESSAGE;
    case 5:
    case "CREATE_COMPANY":
      return AppUsageType.CREATE_COMPANY;
    case 6:
    case "CREATE_IDEA":
      return AppUsageType.CREATE_IDEA;
    case 7:
    case "REPOSITORY_ANALYSIS":
      return AppUsageType.REPOSITORY_ANALYSIS;
    case 8:
    case "REPOSITORY_RESCAN":
      return AppUsageType.REPOSITORY_RESCAN;
    case 9:
    case "SITE_RESCAN":
      return AppUsageType.SITE_RESCAN;
    case 10:
    case "PROMPTS_DOWNLOADS":
      return AppUsageType.PROMPTS_DOWNLOADS;
    case 11:
    case "LINEAR_SYNC":
      return AppUsageType.LINEAR_SYNC;
    case 12:
    case "VIEW_CODING_PROMPTS":
      return AppUsageType.VIEW_CODING_PROMPTS;
    case 13:
    case "REGENERATE_FEATURES":
      return AppUsageType.REGENERATE_FEATURES;
    case 14:
    case "PULSE_ENROLLMENT":
      return AppUsageType.PULSE_ENROLLMENT;
    case 15:
    case "CODE_RESEARCH_ENROLLMENT":
      return AppUsageType.CODE_RESEARCH_ENROLLMENT;
    case 16:
    case "JIRA_SYNC":
      return AppUsageType.JIRA_SYNC;
    case 17:
    case "BITBUCKET_SYNC":
      return AppUsageType.BITBUCKET_SYNC;
    case 18:
    case "PROJECT_SIMULATION":
      return AppUsageType.PROJECT_SIMULATION;
    case 19:
    case "ROADMAP_VIEW":
      return AppUsageType.ROADMAP_VIEW;
    case 20:
    case "RUN_BUTTON_RUNS":
      return AppUsageType.RUN_BUTTON_RUNS;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum AppUsageType");
  }
}

export function appUsageTypeToJSON(object: AppUsageType): string {
  switch (object) {
    case AppUsageType.UNKNOWN_USAGE:
      return "UNKNOWN_USAGE";
    case AppUsageType.CREATE_PROJECT:
      return "CREATE_PROJECT";
    case AppUsageType.CREATE_DOCUMENT:
      return "CREATE_DOCUMENT";
    case AppUsageType.INVITE_USER:
      return "INVITE_USER";
    case AppUsageType.SEND_CHAT_MESSAGE:
      return "SEND_CHAT_MESSAGE";
    case AppUsageType.CREATE_COMPANY:
      return "CREATE_COMPANY";
    case AppUsageType.CREATE_IDEA:
      return "CREATE_IDEA";
    case AppUsageType.REPOSITORY_ANALYSIS:
      return "REPOSITORY_ANALYSIS";
    case AppUsageType.REPOSITORY_RESCAN:
      return "REPOSITORY_RESCAN";
    case AppUsageType.SITE_RESCAN:
      return "SITE_RESCAN";
    case AppUsageType.PROMPTS_DOWNLOADS:
      return "PROMPTS_DOWNLOADS";
    case AppUsageType.LINEAR_SYNC:
      return "LINEAR_SYNC";
    case AppUsageType.VIEW_CODING_PROMPTS:
      return "VIEW_CODING_PROMPTS";
    case AppUsageType.REGENERATE_FEATURES:
      return "REGENERATE_FEATURES";
    case AppUsageType.PULSE_ENROLLMENT:
      return "PULSE_ENROLLMENT";
    case AppUsageType.CODE_RESEARCH_ENROLLMENT:
      return "CODE_RESEARCH_ENROLLMENT";
    case AppUsageType.JIRA_SYNC:
      return "JIRA_SYNC";
    case AppUsageType.BITBUCKET_SYNC:
      return "BITBUCKET_SYNC";
    case AppUsageType.PROJECT_SIMULATION:
      return "PROJECT_SIMULATION";
    case AppUsageType.ROADMAP_VIEW:
      return "ROADMAP_VIEW";
    case AppUsageType.RUN_BUTTON_RUNS:
      return "RUN_BUTTON_RUNS";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum AppUsageType");
  }
}

export enum MeteredEventType {
  UNKNOWN_METERED_EVENT = 0,
  CHAT_MESSAGE = 1,
  USER_STORIES_UPDATE = 2,
  TECH_BRIEF_UPDATE = 3,
  PRODUCT_BRIEF_UPDATE = 4,
  TASKS_UPDATE = 5,
  TASK_PROMPT_UPDATE = 6,
  REPO_SCAN_PER_MILLION_TOKENS = 7,
  REPO_PULSE_PER_MILLION_TOKENS = 8,
  AGGREGATED_PULSE_PER_REPO = 9,
  CUSTOM_DOCUMENT_UPDATE = 10,
  DISCOVERY_BRIEF_UPDATE = 11,
  USER_STORY_PROMPT_UPDATE = 12,
}

export function meteredEventTypeFromJSON(object: any): MeteredEventType {
  switch (object) {
    case 0:
    case "UNKNOWN_METERED_EVENT":
      return MeteredEventType.UNKNOWN_METERED_EVENT;
    case 1:
    case "CHAT_MESSAGE":
      return MeteredEventType.CHAT_MESSAGE;
    case 2:
    case "USER_STORIES_UPDATE":
      return MeteredEventType.USER_STORIES_UPDATE;
    case 3:
    case "TECH_BRIEF_UPDATE":
      return MeteredEventType.TECH_BRIEF_UPDATE;
    case 4:
    case "PRODUCT_BRIEF_UPDATE":
      return MeteredEventType.PRODUCT_BRIEF_UPDATE;
    case 5:
    case "TASKS_UPDATE":
      return MeteredEventType.TASKS_UPDATE;
    case 6:
    case "TASK_PROMPT_UPDATE":
      return MeteredEventType.TASK_PROMPT_UPDATE;
    case 7:
    case "REPO_SCAN_PER_MILLION_TOKENS":
      return MeteredEventType.REPO_SCAN_PER_MILLION_TOKENS;
    case 8:
    case "REPO_PULSE_PER_MILLION_TOKENS":
      return MeteredEventType.REPO_PULSE_PER_MILLION_TOKENS;
    case 9:
    case "AGGREGATED_PULSE_PER_REPO":
      return MeteredEventType.AGGREGATED_PULSE_PER_REPO;
    case 10:
    case "CUSTOM_DOCUMENT_UPDATE":
      return MeteredEventType.CUSTOM_DOCUMENT_UPDATE;
    case 11:
    case "DISCOVERY_BRIEF_UPDATE":
      return MeteredEventType.DISCOVERY_BRIEF_UPDATE;
    case 12:
    case "USER_STORY_PROMPT_UPDATE":
      return MeteredEventType.USER_STORY_PROMPT_UPDATE;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum MeteredEventType");
  }
}

export function meteredEventTypeToJSON(object: MeteredEventType): string {
  switch (object) {
    case MeteredEventType.UNKNOWN_METERED_EVENT:
      return "UNKNOWN_METERED_EVENT";
    case MeteredEventType.CHAT_MESSAGE:
      return "CHAT_MESSAGE";
    case MeteredEventType.USER_STORIES_UPDATE:
      return "USER_STORIES_UPDATE";
    case MeteredEventType.TECH_BRIEF_UPDATE:
      return "TECH_BRIEF_UPDATE";
    case MeteredEventType.PRODUCT_BRIEF_UPDATE:
      return "PRODUCT_BRIEF_UPDATE";
    case MeteredEventType.TASKS_UPDATE:
      return "TASKS_UPDATE";
    case MeteredEventType.TASK_PROMPT_UPDATE:
      return "TASK_PROMPT_UPDATE";
    case MeteredEventType.REPO_SCAN_PER_MILLION_TOKENS:
      return "REPO_SCAN_PER_MILLION_TOKENS";
    case MeteredEventType.REPO_PULSE_PER_MILLION_TOKENS:
      return "REPO_PULSE_PER_MILLION_TOKENS";
    case MeteredEventType.AGGREGATED_PULSE_PER_REPO:
      return "AGGREGATED_PULSE_PER_REPO";
    case MeteredEventType.CUSTOM_DOCUMENT_UPDATE:
      return "CUSTOM_DOCUMENT_UPDATE";
    case MeteredEventType.DISCOVERY_BRIEF_UPDATE:
      return "DISCOVERY_BRIEF_UPDATE";
    case MeteredEventType.USER_STORY_PROMPT_UPDATE:
      return "USER_STORY_PROMPT_UPDATE";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum MeteredEventType");
  }
}

export interface UsageTier {
  id: string;
  name: string;
  archived: boolean;
  descriptionMd: string;
  limits:
    | AppUsageLimits
    | undefined;
  /** Id of the product associated with this tier */
  productId?: string | undefined;
  paid: boolean;
  extraDisplayedFeatures: PlanFeature[];
  featuresListPrefix: string;
  enterprise: EnterpriseTierConfig | undefined;
}

export interface EnterpriseTierConfig {
  enabled: boolean;
  additionalPrices: string[];
}

export interface UserPlan {
  tierId: string;
  name: string;
  descriptionMd: string;
  pricing?: Pricing | undefined;
  features: PlanFeature[];
  featuresListPrefix: string;
  enterprise: boolean;
}

export interface PlanFeature {
  name: string;
  limit: number;
  limitText: string;
}

export interface UserUsageDetails {
  userId: string;
  usageByModel: TokensUsage[];
  createdAt: Date | undefined;
  updatedAt: Date | undefined;
  appUsage: UserAppUsage | undefined;
  lastReset?: Date | undefined;
  nextReset?: Date | undefined;
}

export interface UsageEntry {
  userId?: string | undefined;
  usage: TokensUsage | undefined;
  meta: UsageEntryMeta | undefined;
  createdAt: Date | undefined;
}

export interface UsageEntryMeta {
  agentType?: AgentType | undefined;
  companyId?: number | undefined;
  documentId?: string | undefined;
  projectId?: string | undefined;
}

export interface UserUsageSummary {
  totalTokens: number;
}

export interface UserAppUsage {
  /** Usage by type. Key is UsageType. These values can be reset. */
  usage: { [key: number]: number };
}

export interface UserAppUsage_UsageEntry {
  key: number;
  value: number;
}

export interface AppUsageLimits {
  /**
   * Limits by type. Key is UsageType. Lack of entry indicates the action
   * is not allowed at all.
   */
  unlimited: boolean;
  configs: { [key: number]: AppUsageLimitConfig };
}

export interface AppUsageLimits_ConfigsEntry {
  key: number;
  value: AppUsageLimitConfig | undefined;
}

export interface AppUsageLimitConfig {
  /** -1 limit indicates no limit. */
  limit: number;
  resetMonthly: boolean;
}

export interface AppUsageLimitInfo {
  usage: number;
  limit: number;
  restricted: boolean;
}

export interface CompanyLimits {
  limits: UserLimits | undefined;
  orgId: string;
}

export interface UserLimits {
  appLimits: { [key: number]: AppUsageLimitInfo };
  currentTierId: string;
  forcedReadonly: boolean;
  paid: boolean;
}

export interface UserLimits_AppLimitsEntry {
  key: number;
  value: AppUsageLimitInfo | undefined;
}

export interface Pricing {
  monthly: PriceInfo | undefined;
  annual: PriceInfo | undefined;
  defaultPriceId?: string | undefined;
}

export interface PriceInfo {
  priceId: string;
  priceCents: number;
}

export interface SubscriptionDetails {
  id: string;
  status: string;
  items: SubscriptionItem[];
  customerId: string;
}

export interface SubscriptionItem {
  id: string;
  priceId: string;
}

export interface EnterpriseSubscriptionDetails {
  orgId: string;
  tierId: string;
  subscription: SubscriptionDetails | undefined;
}

export interface CreditsPricing {
  pricing: EventCreditsPrice[];
}

export interface EventCreditsPrice {
  eventType: MeteredEventType;
  creditsPerEvent: number;
}

function createBaseUsageTier(): UsageTier {
  return {
    id: "",
    name: "",
    archived: false,
    descriptionMd: "",
    limits: undefined,
    productId: undefined,
    paid: false,
    extraDisplayedFeatures: [],
    featuresListPrefix: "",
    enterprise: undefined,
  };
}

export const UsageTier: MessageFns<UsageTier> = {
  encode(message: UsageTier, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.archived !== false) {
      writer.uint32(24).bool(message.archived);
    }
    if (message.descriptionMd !== "") {
      writer.uint32(34).string(message.descriptionMd);
    }
    if (message.limits !== undefined) {
      AppUsageLimits.encode(message.limits, writer.uint32(42).fork()).join();
    }
    if (message.productId !== undefined) {
      writer.uint32(58).string(message.productId);
    }
    if (message.paid !== false) {
      writer.uint32(64).bool(message.paid);
    }
    for (const v of message.extraDisplayedFeatures) {
      PlanFeature.encode(v!, writer.uint32(74).fork()).join();
    }
    if (message.featuresListPrefix !== "") {
      writer.uint32(82).string(message.featuresListPrefix);
    }
    if (message.enterprise !== undefined) {
      EnterpriseTierConfig.encode(message.enterprise, writer.uint32(90).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UsageTier {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUsageTier();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.archived = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.descriptionMd = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.limits = AppUsageLimits.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.productId = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.paid = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.extraDisplayedFeatures.push(PlanFeature.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.featuresListPrefix = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.enterprise = EnterpriseTierConfig.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UsageTier {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      archived: isSet(object.archived) ? globalThis.Boolean(object.archived) : false,
      descriptionMd: isSet(object.descriptionMd)
        ? globalThis.String(object.descriptionMd)
        : isSet(object.description_md)
        ? globalThis.String(object.description_md)
        : "",
      limits: isSet(object.limits) ? AppUsageLimits.fromJSON(object.limits) : undefined,
      productId: isSet(object.productId)
        ? globalThis.String(object.productId)
        : isSet(object.product_id)
        ? globalThis.String(object.product_id)
        : undefined,
      paid: isSet(object.paid) ? globalThis.Boolean(object.paid) : false,
      extraDisplayedFeatures: globalThis.Array.isArray(object?.extraDisplayedFeatures)
        ? object.extraDisplayedFeatures.map((e: any) => PlanFeature.fromJSON(e))
        : globalThis.Array.isArray(object?.extra_displayed_features)
        ? object.extra_displayed_features.map((e: any) => PlanFeature.fromJSON(e))
        : [],
      featuresListPrefix: isSet(object.featuresListPrefix)
        ? globalThis.String(object.featuresListPrefix)
        : isSet(object.features_list_prefix)
        ? globalThis.String(object.features_list_prefix)
        : "",
      enterprise: isSet(object.enterprise) ? EnterpriseTierConfig.fromJSON(object.enterprise) : undefined,
    };
  },

  toJSON(message: UsageTier): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.archived !== false) {
      obj.archived = message.archived;
    }
    if (message.descriptionMd !== "") {
      obj.descriptionMd = message.descriptionMd;
    }
    if (message.limits !== undefined) {
      obj.limits = AppUsageLimits.toJSON(message.limits);
    }
    if (message.productId !== undefined) {
      obj.productId = message.productId;
    }
    if (message.paid !== false) {
      obj.paid = message.paid;
    }
    if (message.extraDisplayedFeatures?.length) {
      obj.extraDisplayedFeatures = message.extraDisplayedFeatures.map((e) => PlanFeature.toJSON(e));
    }
    if (message.featuresListPrefix !== "") {
      obj.featuresListPrefix = message.featuresListPrefix;
    }
    if (message.enterprise !== undefined) {
      obj.enterprise = EnterpriseTierConfig.toJSON(message.enterprise);
    }
    return obj;
  },

  create(base?: DeepPartial<UsageTier>): UsageTier {
    return UsageTier.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UsageTier>): UsageTier {
    const message = createBaseUsageTier();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.archived = object.archived ?? false;
    message.descriptionMd = object.descriptionMd ?? "";
    message.limits = (object.limits !== undefined && object.limits !== null)
      ? AppUsageLimits.fromPartial(object.limits)
      : undefined;
    message.productId = object.productId ?? undefined;
    message.paid = object.paid ?? false;
    message.extraDisplayedFeatures = object.extraDisplayedFeatures?.map((e) => PlanFeature.fromPartial(e)) || [];
    message.featuresListPrefix = object.featuresListPrefix ?? "";
    message.enterprise = (object.enterprise !== undefined && object.enterprise !== null)
      ? EnterpriseTierConfig.fromPartial(object.enterprise)
      : undefined;
    return message;
  },
};

function createBaseEnterpriseTierConfig(): EnterpriseTierConfig {
  return { enabled: false, additionalPrices: [] };
}

export const EnterpriseTierConfig: MessageFns<EnterpriseTierConfig> = {
  encode(message: EnterpriseTierConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.enabled !== false) {
      writer.uint32(8).bool(message.enabled);
    }
    for (const v of message.additionalPrices) {
      writer.uint32(18).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EnterpriseTierConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEnterpriseTierConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.additionalPrices.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EnterpriseTierConfig {
    return {
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      additionalPrices: globalThis.Array.isArray(object?.additionalPrices)
        ? object.additionalPrices.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.additional_prices)
        ? object.additional_prices.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: EnterpriseTierConfig): unknown {
    const obj: any = {};
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.additionalPrices?.length) {
      obj.additionalPrices = message.additionalPrices;
    }
    return obj;
  },

  create(base?: DeepPartial<EnterpriseTierConfig>): EnterpriseTierConfig {
    return EnterpriseTierConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<EnterpriseTierConfig>): EnterpriseTierConfig {
    const message = createBaseEnterpriseTierConfig();
    message.enabled = object.enabled ?? false;
    message.additionalPrices = object.additionalPrices?.map((e) => e) || [];
    return message;
  },
};

function createBaseUserPlan(): UserPlan {
  return {
    tierId: "",
    name: "",
    descriptionMd: "",
    pricing: undefined,
    features: [],
    featuresListPrefix: "",
    enterprise: false,
  };
}

export const UserPlan: MessageFns<UserPlan> = {
  encode(message: UserPlan, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tierId !== "") {
      writer.uint32(10).string(message.tierId);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.descriptionMd !== "") {
      writer.uint32(26).string(message.descriptionMd);
    }
    if (message.pricing !== undefined) {
      Pricing.encode(message.pricing, writer.uint32(34).fork()).join();
    }
    for (const v of message.features) {
      PlanFeature.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.featuresListPrefix !== "") {
      writer.uint32(50).string(message.featuresListPrefix);
    }
    if (message.enterprise !== false) {
      writer.uint32(56).bool(message.enterprise);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UserPlan {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserPlan();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tierId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.descriptionMd = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.pricing = Pricing.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.features.push(PlanFeature.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.featuresListPrefix = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.enterprise = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserPlan {
    return {
      tierId: isSet(object.tierId)
        ? globalThis.String(object.tierId)
        : isSet(object.tier_id)
        ? globalThis.String(object.tier_id)
        : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      descriptionMd: isSet(object.descriptionMd)
        ? globalThis.String(object.descriptionMd)
        : isSet(object.description_md)
        ? globalThis.String(object.description_md)
        : "",
      pricing: isSet(object.pricing) ? Pricing.fromJSON(object.pricing) : undefined,
      features: globalThis.Array.isArray(object?.features)
        ? object.features.map((e: any) => PlanFeature.fromJSON(e))
        : [],
      featuresListPrefix: isSet(object.featuresListPrefix)
        ? globalThis.String(object.featuresListPrefix)
        : isSet(object.features_list_prefix)
        ? globalThis.String(object.features_list_prefix)
        : "",
      enterprise: isSet(object.enterprise) ? globalThis.Boolean(object.enterprise) : false,
    };
  },

  toJSON(message: UserPlan): unknown {
    const obj: any = {};
    if (message.tierId !== "") {
      obj.tierId = message.tierId;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.descriptionMd !== "") {
      obj.descriptionMd = message.descriptionMd;
    }
    if (message.pricing !== undefined) {
      obj.pricing = Pricing.toJSON(message.pricing);
    }
    if (message.features?.length) {
      obj.features = message.features.map((e) => PlanFeature.toJSON(e));
    }
    if (message.featuresListPrefix !== "") {
      obj.featuresListPrefix = message.featuresListPrefix;
    }
    if (message.enterprise !== false) {
      obj.enterprise = message.enterprise;
    }
    return obj;
  },

  create(base?: DeepPartial<UserPlan>): UserPlan {
    return UserPlan.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UserPlan>): UserPlan {
    const message = createBaseUserPlan();
    message.tierId = object.tierId ?? "";
    message.name = object.name ?? "";
    message.descriptionMd = object.descriptionMd ?? "";
    message.pricing = (object.pricing !== undefined && object.pricing !== null)
      ? Pricing.fromPartial(object.pricing)
      : undefined;
    message.features = object.features?.map((e) => PlanFeature.fromPartial(e)) || [];
    message.featuresListPrefix = object.featuresListPrefix ?? "";
    message.enterprise = object.enterprise ?? false;
    return message;
  },
};

function createBasePlanFeature(): PlanFeature {
  return { name: "", limit: 0, limitText: "" };
}

export const PlanFeature: MessageFns<PlanFeature> = {
  encode(message: PlanFeature, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.limit !== 0) {
      writer.uint32(16).int32(message.limit);
    }
    if (message.limitText !== "") {
      writer.uint32(26).string(message.limitText);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanFeature {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanFeature();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.limit = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.limitText = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanFeature {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      limit: isSet(object.limit) ? globalThis.Number(object.limit) : 0,
      limitText: isSet(object.limitText)
        ? globalThis.String(object.limitText)
        : isSet(object.limit_text)
        ? globalThis.String(object.limit_text)
        : "",
    };
  },

  toJSON(message: PlanFeature): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.limit !== 0) {
      obj.limit = Math.round(message.limit);
    }
    if (message.limitText !== "") {
      obj.limitText = message.limitText;
    }
    return obj;
  },

  create(base?: DeepPartial<PlanFeature>): PlanFeature {
    return PlanFeature.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PlanFeature>): PlanFeature {
    const message = createBasePlanFeature();
    message.name = object.name ?? "";
    message.limit = object.limit ?? 0;
    message.limitText = object.limitText ?? "";
    return message;
  },
};

function createBaseUserUsageDetails(): UserUsageDetails {
  return {
    userId: "",
    usageByModel: [],
    createdAt: undefined,
    updatedAt: undefined,
    appUsage: undefined,
    lastReset: undefined,
    nextReset: undefined,
  };
}

export const UserUsageDetails: MessageFns<UserUsageDetails> = {
  encode(message: UserUsageDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.userId !== "") {
      writer.uint32(10).string(message.userId);
    }
    for (const v of message.usageByModel) {
      TokensUsage.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(26).fork()).join();
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(34).fork()).join();
    }
    if (message.appUsage !== undefined) {
      UserAppUsage.encode(message.appUsage, writer.uint32(42).fork()).join();
    }
    if (message.lastReset !== undefined) {
      Timestamp.encode(toTimestamp(message.lastReset), writer.uint32(50).fork()).join();
    }
    if (message.nextReset !== undefined) {
      Timestamp.encode(toTimestamp(message.nextReset), writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UserUsageDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserUsageDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.userId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.usageByModel.push(TokensUsage.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.appUsage = UserAppUsage.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.lastReset = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.nextReset = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserUsageDetails {
    return {
      userId: isSet(object.userId)
        ? globalThis.String(object.userId)
        : isSet(object.user_id)
        ? globalThis.String(object.user_id)
        : "",
      usageByModel: globalThis.Array.isArray(object?.usageByModel)
        ? object.usageByModel.map((e: any) => TokensUsage.fromJSON(e))
        : globalThis.Array.isArray(object?.usage_by_model)
        ? object.usage_by_model.map((e: any) => TokensUsage.fromJSON(e))
        : [],
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      appUsage: isSet(object.appUsage)
        ? UserAppUsage.fromJSON(object.appUsage)
        : isSet(object.app_usage)
        ? UserAppUsage.fromJSON(object.app_usage)
        : undefined,
      lastReset: isSet(object.lastReset)
        ? fromJsonTimestamp(object.lastReset)
        : isSet(object.last_reset)
        ? fromJsonTimestamp(object.last_reset)
        : undefined,
      nextReset: isSet(object.nextReset)
        ? fromJsonTimestamp(object.nextReset)
        : isSet(object.next_reset)
        ? fromJsonTimestamp(object.next_reset)
        : undefined,
    };
  },

  toJSON(message: UserUsageDetails): unknown {
    const obj: any = {};
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.usageByModel?.length) {
      obj.usageByModel = message.usageByModel.map((e) => TokensUsage.toJSON(e));
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.appUsage !== undefined) {
      obj.appUsage = UserAppUsage.toJSON(message.appUsage);
    }
    if (message.lastReset !== undefined) {
      obj.lastReset = message.lastReset.toISOString();
    }
    if (message.nextReset !== undefined) {
      obj.nextReset = message.nextReset.toISOString();
    }
    return obj;
  },

  create(base?: DeepPartial<UserUsageDetails>): UserUsageDetails {
    return UserUsageDetails.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UserUsageDetails>): UserUsageDetails {
    const message = createBaseUserUsageDetails();
    message.userId = object.userId ?? "";
    message.usageByModel = object.usageByModel?.map((e) => TokensUsage.fromPartial(e)) || [];
    message.createdAt = object.createdAt ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    message.appUsage = (object.appUsage !== undefined && object.appUsage !== null)
      ? UserAppUsage.fromPartial(object.appUsage)
      : undefined;
    message.lastReset = object.lastReset ?? undefined;
    message.nextReset = object.nextReset ?? undefined;
    return message;
  },
};

function createBaseUsageEntry(): UsageEntry {
  return { userId: undefined, usage: undefined, meta: undefined, createdAt: undefined };
}

export const UsageEntry: MessageFns<UsageEntry> = {
  encode(message: UsageEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.userId !== undefined) {
      writer.uint32(10).string(message.userId);
    }
    if (message.usage !== undefined) {
      TokensUsage.encode(message.usage, writer.uint32(18).fork()).join();
    }
    if (message.meta !== undefined) {
      UsageEntryMeta.encode(message.meta, writer.uint32(26).fork()).join();
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UsageEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUsageEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.userId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.usage = TokensUsage.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.meta = UsageEntryMeta.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UsageEntry {
    return {
      userId: isSet(object.userId)
        ? globalThis.String(object.userId)
        : isSet(object.user_id)
        ? globalThis.String(object.user_id)
        : undefined,
      usage: isSet(object.usage) ? TokensUsage.fromJSON(object.usage) : undefined,
      meta: isSet(object.meta) ? UsageEntryMeta.fromJSON(object.meta) : undefined,
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
    };
  },

  toJSON(message: UsageEntry): unknown {
    const obj: any = {};
    if (message.userId !== undefined) {
      obj.userId = message.userId;
    }
    if (message.usage !== undefined) {
      obj.usage = TokensUsage.toJSON(message.usage);
    }
    if (message.meta !== undefined) {
      obj.meta = UsageEntryMeta.toJSON(message.meta);
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    return obj;
  },

  create(base?: DeepPartial<UsageEntry>): UsageEntry {
    return UsageEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UsageEntry>): UsageEntry {
    const message = createBaseUsageEntry();
    message.userId = object.userId ?? undefined;
    message.usage = (object.usage !== undefined && object.usage !== null)
      ? TokensUsage.fromPartial(object.usage)
      : undefined;
    message.meta = (object.meta !== undefined && object.meta !== null)
      ? UsageEntryMeta.fromPartial(object.meta)
      : undefined;
    message.createdAt = object.createdAt ?? undefined;
    return message;
  },
};

function createBaseUsageEntryMeta(): UsageEntryMeta {
  return { agentType: undefined, companyId: undefined, documentId: undefined, projectId: undefined };
}

export const UsageEntryMeta: MessageFns<UsageEntryMeta> = {
  encode(message: UsageEntryMeta, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.agentType !== undefined) {
      writer.uint32(8).int32(message.agentType);
    }
    if (message.companyId !== undefined) {
      writer.uint32(24).int32(message.companyId);
    }
    if (message.documentId !== undefined) {
      writer.uint32(34).string(message.documentId);
    }
    if (message.projectId !== undefined) {
      writer.uint32(42).string(message.projectId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UsageEntryMeta {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUsageEntryMeta();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.agentType = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.documentId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.projectId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UsageEntryMeta {
    return {
      agentType: isSet(object.agentType)
        ? agentTypeFromJSON(object.agentType)
        : isSet(object.agent_type)
        ? agentTypeFromJSON(object.agent_type)
        : undefined,
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : undefined,
      documentId: isSet(object.documentId)
        ? globalThis.String(object.documentId)
        : isSet(object.document_id)
        ? globalThis.String(object.document_id)
        : undefined,
      projectId: isSet(object.projectId)
        ? globalThis.String(object.projectId)
        : isSet(object.project_id)
        ? globalThis.String(object.project_id)
        : undefined,
    };
  },

  toJSON(message: UsageEntryMeta): unknown {
    const obj: any = {};
    if (message.agentType !== undefined) {
      obj.agentType = agentTypeToJSON(message.agentType);
    }
    if (message.companyId !== undefined) {
      obj.companyId = Math.round(message.companyId);
    }
    if (message.documentId !== undefined) {
      obj.documentId = message.documentId;
    }
    if (message.projectId !== undefined) {
      obj.projectId = message.projectId;
    }
    return obj;
  },

  create(base?: DeepPartial<UsageEntryMeta>): UsageEntryMeta {
    return UsageEntryMeta.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UsageEntryMeta>): UsageEntryMeta {
    const message = createBaseUsageEntryMeta();
    message.agentType = object.agentType ?? undefined;
    message.companyId = object.companyId ?? undefined;
    message.documentId = object.documentId ?? undefined;
    message.projectId = object.projectId ?? undefined;
    return message;
  },
};

function createBaseUserUsageSummary(): UserUsageSummary {
  return { totalTokens: 0 };
}

export const UserUsageSummary: MessageFns<UserUsageSummary> = {
  encode(message: UserUsageSummary, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.totalTokens !== 0) {
      writer.uint32(8).int32(message.totalTokens);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UserUsageSummary {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserUsageSummary();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.totalTokens = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserUsageSummary {
    return {
      totalTokens: isSet(object.totalTokens)
        ? globalThis.Number(object.totalTokens)
        : isSet(object.total_tokens)
        ? globalThis.Number(object.total_tokens)
        : 0,
    };
  },

  toJSON(message: UserUsageSummary): unknown {
    const obj: any = {};
    if (message.totalTokens !== 0) {
      obj.totalTokens = Math.round(message.totalTokens);
    }
    return obj;
  },

  create(base?: DeepPartial<UserUsageSummary>): UserUsageSummary {
    return UserUsageSummary.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UserUsageSummary>): UserUsageSummary {
    const message = createBaseUserUsageSummary();
    message.totalTokens = object.totalTokens ?? 0;
    return message;
  },
};

function createBaseUserAppUsage(): UserAppUsage {
  return { usage: {} };
}

export const UserAppUsage: MessageFns<UserAppUsage> = {
  encode(message: UserAppUsage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    globalThis.Object.entries(message.usage).forEach(([key, value]: [string, number]) => {
      UserAppUsage_UsageEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UserAppUsage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserAppUsage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = UserAppUsage_UsageEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.usage[entry1.key] = entry1.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserAppUsage {
    return {
      usage: isObject(object.usage)
        ? (globalThis.Object.entries(object.usage) as [string, any][]).reduce(
          (acc: { [key: number]: number }, [key, value]: [string, any]) => {
            acc[globalThis.Number(key)] = globalThis.Number(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: UserAppUsage): unknown {
    const obj: any = {};
    if (message.usage) {
      const entries = globalThis.Object.entries(message.usage) as [string, number][];
      if (entries.length > 0) {
        obj.usage = {};
        entries.forEach(([k, v]) => {
          obj.usage[k] = Math.round(v);
        });
      }
    }
    return obj;
  },

  create(base?: DeepPartial<UserAppUsage>): UserAppUsage {
    return UserAppUsage.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UserAppUsage>): UserAppUsage {
    const message = createBaseUserAppUsage();
    message.usage = (globalThis.Object.entries(object.usage ?? {}) as [string, number][]).reduce(
      (acc: { [key: number]: number }, [key, value]: [string, number]) => {
        if (value !== undefined) {
          acc[globalThis.Number(key)] = globalThis.Number(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseUserAppUsage_UsageEntry(): UserAppUsage_UsageEntry {
  return { key: 0, value: 0 };
}

export const UserAppUsage_UsageEntry: MessageFns<UserAppUsage_UsageEntry> = {
  encode(message: UserAppUsage_UsageEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== 0) {
      writer.uint32(8).int32(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(16).int32(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UserAppUsage_UsageEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserAppUsage_UsageEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.key = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserAppUsage_UsageEntry {
    return {
      key: isSet(object.key) ? globalThis.Number(object.key) : 0,
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: UserAppUsage_UsageEntry): unknown {
    const obj: any = {};
    if (message.key !== 0) {
      obj.key = Math.round(message.key);
    }
    if (message.value !== 0) {
      obj.value = Math.round(message.value);
    }
    return obj;
  },

  create(base?: DeepPartial<UserAppUsage_UsageEntry>): UserAppUsage_UsageEntry {
    return UserAppUsage_UsageEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UserAppUsage_UsageEntry>): UserAppUsage_UsageEntry {
    const message = createBaseUserAppUsage_UsageEntry();
    message.key = object.key ?? 0;
    message.value = object.value ?? 0;
    return message;
  },
};

function createBaseAppUsageLimits(): AppUsageLimits {
  return { unlimited: false, configs: {} };
}

export const AppUsageLimits: MessageFns<AppUsageLimits> = {
  encode(message: AppUsageLimits, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.unlimited !== false) {
      writer.uint32(16).bool(message.unlimited);
    }
    globalThis.Object.entries(message.configs).forEach(([key, value]: [string, AppUsageLimitConfig]) => {
      AppUsageLimits_ConfigsEntry.encode({ key: key as any, value }, writer.uint32(26).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AppUsageLimits {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAppUsageLimits();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.unlimited = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          const entry3 = AppUsageLimits_ConfigsEntry.decode(reader, reader.uint32());
          if (entry3.value !== undefined) {
            message.configs[entry3.key] = entry3.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AppUsageLimits {
    return {
      unlimited: isSet(object.unlimited) ? globalThis.Boolean(object.unlimited) : false,
      configs: isObject(object.configs)
        ? (globalThis.Object.entries(object.configs) as [string, any][]).reduce(
          (acc: { [key: number]: AppUsageLimitConfig }, [key, value]: [string, any]) => {
            acc[globalThis.Number(key)] = AppUsageLimitConfig.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: AppUsageLimits): unknown {
    const obj: any = {};
    if (message.unlimited !== false) {
      obj.unlimited = message.unlimited;
    }
    if (message.configs) {
      const entries = globalThis.Object.entries(message.configs) as [string, AppUsageLimitConfig][];
      if (entries.length > 0) {
        obj.configs = {};
        entries.forEach(([k, v]) => {
          obj.configs[k] = AppUsageLimitConfig.toJSON(v);
        });
      }
    }
    return obj;
  },

  create(base?: DeepPartial<AppUsageLimits>): AppUsageLimits {
    return AppUsageLimits.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AppUsageLimits>): AppUsageLimits {
    const message = createBaseAppUsageLimits();
    message.unlimited = object.unlimited ?? false;
    message.configs = (globalThis.Object.entries(object.configs ?? {}) as [string, AppUsageLimitConfig][]).reduce(
      (acc: { [key: number]: AppUsageLimitConfig }, [key, value]: [string, AppUsageLimitConfig]) => {
        if (value !== undefined) {
          acc[globalThis.Number(key)] = AppUsageLimitConfig.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseAppUsageLimits_ConfigsEntry(): AppUsageLimits_ConfigsEntry {
  return { key: 0, value: undefined };
}

export const AppUsageLimits_ConfigsEntry: MessageFns<AppUsageLimits_ConfigsEntry> = {
  encode(message: AppUsageLimits_ConfigsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== 0) {
      writer.uint32(8).int32(message.key);
    }
    if (message.value !== undefined) {
      AppUsageLimitConfig.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AppUsageLimits_ConfigsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAppUsageLimits_ConfigsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.key = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = AppUsageLimitConfig.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AppUsageLimits_ConfigsEntry {
    return {
      key: isSet(object.key) ? globalThis.Number(object.key) : 0,
      value: isSet(object.value) ? AppUsageLimitConfig.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: AppUsageLimits_ConfigsEntry): unknown {
    const obj: any = {};
    if (message.key !== 0) {
      obj.key = Math.round(message.key);
    }
    if (message.value !== undefined) {
      obj.value = AppUsageLimitConfig.toJSON(message.value);
    }
    return obj;
  },

  create(base?: DeepPartial<AppUsageLimits_ConfigsEntry>): AppUsageLimits_ConfigsEntry {
    return AppUsageLimits_ConfigsEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AppUsageLimits_ConfigsEntry>): AppUsageLimits_ConfigsEntry {
    const message = createBaseAppUsageLimits_ConfigsEntry();
    message.key = object.key ?? 0;
    message.value = (object.value !== undefined && object.value !== null)
      ? AppUsageLimitConfig.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseAppUsageLimitConfig(): AppUsageLimitConfig {
  return { limit: 0, resetMonthly: false };
}

export const AppUsageLimitConfig: MessageFns<AppUsageLimitConfig> = {
  encode(message: AppUsageLimitConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.limit !== 0) {
      writer.uint32(8).int32(message.limit);
    }
    if (message.resetMonthly !== false) {
      writer.uint32(16).bool(message.resetMonthly);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AppUsageLimitConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAppUsageLimitConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.limit = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.resetMonthly = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AppUsageLimitConfig {
    return {
      limit: isSet(object.limit) ? globalThis.Number(object.limit) : 0,
      resetMonthly: isSet(object.resetMonthly)
        ? globalThis.Boolean(object.resetMonthly)
        : isSet(object.reset_monthly)
        ? globalThis.Boolean(object.reset_monthly)
        : false,
    };
  },

  toJSON(message: AppUsageLimitConfig): unknown {
    const obj: any = {};
    if (message.limit !== 0) {
      obj.limit = Math.round(message.limit);
    }
    if (message.resetMonthly !== false) {
      obj.resetMonthly = message.resetMonthly;
    }
    return obj;
  },

  create(base?: DeepPartial<AppUsageLimitConfig>): AppUsageLimitConfig {
    return AppUsageLimitConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AppUsageLimitConfig>): AppUsageLimitConfig {
    const message = createBaseAppUsageLimitConfig();
    message.limit = object.limit ?? 0;
    message.resetMonthly = object.resetMonthly ?? false;
    return message;
  },
};

function createBaseAppUsageLimitInfo(): AppUsageLimitInfo {
  return { usage: 0, limit: 0, restricted: false };
}

export const AppUsageLimitInfo: MessageFns<AppUsageLimitInfo> = {
  encode(message: AppUsageLimitInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.usage !== 0) {
      writer.uint32(8).int32(message.usage);
    }
    if (message.limit !== 0) {
      writer.uint32(16).int32(message.limit);
    }
    if (message.restricted !== false) {
      writer.uint32(24).bool(message.restricted);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AppUsageLimitInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAppUsageLimitInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.usage = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.limit = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.restricted = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AppUsageLimitInfo {
    return {
      usage: isSet(object.usage) ? globalThis.Number(object.usage) : 0,
      limit: isSet(object.limit) ? globalThis.Number(object.limit) : 0,
      restricted: isSet(object.restricted) ? globalThis.Boolean(object.restricted) : false,
    };
  },

  toJSON(message: AppUsageLimitInfo): unknown {
    const obj: any = {};
    if (message.usage !== 0) {
      obj.usage = Math.round(message.usage);
    }
    if (message.limit !== 0) {
      obj.limit = Math.round(message.limit);
    }
    if (message.restricted !== false) {
      obj.restricted = message.restricted;
    }
    return obj;
  },

  create(base?: DeepPartial<AppUsageLimitInfo>): AppUsageLimitInfo {
    return AppUsageLimitInfo.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AppUsageLimitInfo>): AppUsageLimitInfo {
    const message = createBaseAppUsageLimitInfo();
    message.usage = object.usage ?? 0;
    message.limit = object.limit ?? 0;
    message.restricted = object.restricted ?? false;
    return message;
  },
};

function createBaseCompanyLimits(): CompanyLimits {
  return { limits: undefined, orgId: "" };
}

export const CompanyLimits: MessageFns<CompanyLimits> = {
  encode(message: CompanyLimits, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.limits !== undefined) {
      UserLimits.encode(message.limits, writer.uint32(10).fork()).join();
    }
    if (message.orgId !== "") {
      writer.uint32(18).string(message.orgId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CompanyLimits {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompanyLimits();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.limits = UserLimits.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompanyLimits {
    return {
      limits: isSet(object.limits) ? UserLimits.fromJSON(object.limits) : undefined,
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
    };
  },

  toJSON(message: CompanyLimits): unknown {
    const obj: any = {};
    if (message.limits !== undefined) {
      obj.limits = UserLimits.toJSON(message.limits);
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    return obj;
  },

  create(base?: DeepPartial<CompanyLimits>): CompanyLimits {
    return CompanyLimits.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CompanyLimits>): CompanyLimits {
    const message = createBaseCompanyLimits();
    message.limits = (object.limits !== undefined && object.limits !== null)
      ? UserLimits.fromPartial(object.limits)
      : undefined;
    message.orgId = object.orgId ?? "";
    return message;
  },
};

function createBaseUserLimits(): UserLimits {
  return { appLimits: {}, currentTierId: "", forcedReadonly: false, paid: false };
}

export const UserLimits: MessageFns<UserLimits> = {
  encode(message: UserLimits, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    globalThis.Object.entries(message.appLimits).forEach(([key, value]: [string, AppUsageLimitInfo]) => {
      UserLimits_AppLimitsEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    if (message.currentTierId !== "") {
      writer.uint32(18).string(message.currentTierId);
    }
    if (message.forcedReadonly !== false) {
      writer.uint32(24).bool(message.forcedReadonly);
    }
    if (message.paid !== false) {
      writer.uint32(32).bool(message.paid);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UserLimits {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserLimits();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = UserLimits_AppLimitsEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.appLimits[entry1.key] = entry1.value;
          }
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.currentTierId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.forcedReadonly = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.paid = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserLimits {
    return {
      appLimits: isObject(object.appLimits)
        ? (globalThis.Object.entries(object.appLimits) as [string, any][]).reduce(
          (acc: { [key: number]: AppUsageLimitInfo }, [key, value]: [string, any]) => {
            acc[globalThis.Number(key)] = AppUsageLimitInfo.fromJSON(value);
            return acc;
          },
          {},
        )
        : isObject(object.app_limits)
        ? (globalThis.Object.entries(object.app_limits) as [string, any][]).reduce(
          (acc: { [key: number]: AppUsageLimitInfo }, [key, value]: [string, any]) => {
            acc[globalThis.Number(key)] = AppUsageLimitInfo.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
      currentTierId: isSet(object.currentTierId)
        ? globalThis.String(object.currentTierId)
        : isSet(object.current_tier_id)
        ? globalThis.String(object.current_tier_id)
        : "",
      forcedReadonly: isSet(object.forcedReadonly)
        ? globalThis.Boolean(object.forcedReadonly)
        : isSet(object.forced_readonly)
        ? globalThis.Boolean(object.forced_readonly)
        : false,
      paid: isSet(object.paid) ? globalThis.Boolean(object.paid) : false,
    };
  },

  toJSON(message: UserLimits): unknown {
    const obj: any = {};
    if (message.appLimits) {
      const entries = globalThis.Object.entries(message.appLimits) as [string, AppUsageLimitInfo][];
      if (entries.length > 0) {
        obj.appLimits = {};
        entries.forEach(([k, v]) => {
          obj.appLimits[k] = AppUsageLimitInfo.toJSON(v);
        });
      }
    }
    if (message.currentTierId !== "") {
      obj.currentTierId = message.currentTierId;
    }
    if (message.forcedReadonly !== false) {
      obj.forcedReadonly = message.forcedReadonly;
    }
    if (message.paid !== false) {
      obj.paid = message.paid;
    }
    return obj;
  },

  create(base?: DeepPartial<UserLimits>): UserLimits {
    return UserLimits.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UserLimits>): UserLimits {
    const message = createBaseUserLimits();
    message.appLimits = (globalThis.Object.entries(object.appLimits ?? {}) as [string, AppUsageLimitInfo][]).reduce(
      (acc: { [key: number]: AppUsageLimitInfo }, [key, value]: [string, AppUsageLimitInfo]) => {
        if (value !== undefined) {
          acc[globalThis.Number(key)] = AppUsageLimitInfo.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    message.currentTierId = object.currentTierId ?? "";
    message.forcedReadonly = object.forcedReadonly ?? false;
    message.paid = object.paid ?? false;
    return message;
  },
};

function createBaseUserLimits_AppLimitsEntry(): UserLimits_AppLimitsEntry {
  return { key: 0, value: undefined };
}

export const UserLimits_AppLimitsEntry: MessageFns<UserLimits_AppLimitsEntry> = {
  encode(message: UserLimits_AppLimitsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== 0) {
      writer.uint32(8).int32(message.key);
    }
    if (message.value !== undefined) {
      AppUsageLimitInfo.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UserLimits_AppLimitsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserLimits_AppLimitsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.key = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = AppUsageLimitInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserLimits_AppLimitsEntry {
    return {
      key: isSet(object.key) ? globalThis.Number(object.key) : 0,
      value: isSet(object.value) ? AppUsageLimitInfo.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: UserLimits_AppLimitsEntry): unknown {
    const obj: any = {};
    if (message.key !== 0) {
      obj.key = Math.round(message.key);
    }
    if (message.value !== undefined) {
      obj.value = AppUsageLimitInfo.toJSON(message.value);
    }
    return obj;
  },

  create(base?: DeepPartial<UserLimits_AppLimitsEntry>): UserLimits_AppLimitsEntry {
    return UserLimits_AppLimitsEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UserLimits_AppLimitsEntry>): UserLimits_AppLimitsEntry {
    const message = createBaseUserLimits_AppLimitsEntry();
    message.key = object.key ?? 0;
    message.value = (object.value !== undefined && object.value !== null)
      ? AppUsageLimitInfo.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBasePricing(): Pricing {
  return { monthly: undefined, annual: undefined, defaultPriceId: undefined };
}

export const Pricing: MessageFns<Pricing> = {
  encode(message: Pricing, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.monthly !== undefined) {
      PriceInfo.encode(message.monthly, writer.uint32(10).fork()).join();
    }
    if (message.annual !== undefined) {
      PriceInfo.encode(message.annual, writer.uint32(18).fork()).join();
    }
    if (message.defaultPriceId !== undefined) {
      writer.uint32(26).string(message.defaultPriceId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Pricing {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePricing();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.monthly = PriceInfo.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.annual = PriceInfo.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.defaultPriceId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Pricing {
    return {
      monthly: isSet(object.monthly) ? PriceInfo.fromJSON(object.monthly) : undefined,
      annual: isSet(object.annual) ? PriceInfo.fromJSON(object.annual) : undefined,
      defaultPriceId: isSet(object.defaultPriceId)
        ? globalThis.String(object.defaultPriceId)
        : isSet(object.default_price_id)
        ? globalThis.String(object.default_price_id)
        : undefined,
    };
  },

  toJSON(message: Pricing): unknown {
    const obj: any = {};
    if (message.monthly !== undefined) {
      obj.monthly = PriceInfo.toJSON(message.monthly);
    }
    if (message.annual !== undefined) {
      obj.annual = PriceInfo.toJSON(message.annual);
    }
    if (message.defaultPriceId !== undefined) {
      obj.defaultPriceId = message.defaultPriceId;
    }
    return obj;
  },

  create(base?: DeepPartial<Pricing>): Pricing {
    return Pricing.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Pricing>): Pricing {
    const message = createBasePricing();
    message.monthly = (object.monthly !== undefined && object.monthly !== null)
      ? PriceInfo.fromPartial(object.monthly)
      : undefined;
    message.annual = (object.annual !== undefined && object.annual !== null)
      ? PriceInfo.fromPartial(object.annual)
      : undefined;
    message.defaultPriceId = object.defaultPriceId ?? undefined;
    return message;
  },
};

function createBasePriceInfo(): PriceInfo {
  return { priceId: "", priceCents: 0 };
}

export const PriceInfo: MessageFns<PriceInfo> = {
  encode(message: PriceInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.priceId !== "") {
      writer.uint32(10).string(message.priceId);
    }
    if (message.priceCents !== 0) {
      writer.uint32(16).int32(message.priceCents);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PriceInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePriceInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.priceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.priceCents = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PriceInfo {
    return {
      priceId: isSet(object.priceId)
        ? globalThis.String(object.priceId)
        : isSet(object.price_id)
        ? globalThis.String(object.price_id)
        : "",
      priceCents: isSet(object.priceCents)
        ? globalThis.Number(object.priceCents)
        : isSet(object.price_cents)
        ? globalThis.Number(object.price_cents)
        : 0,
    };
  },

  toJSON(message: PriceInfo): unknown {
    const obj: any = {};
    if (message.priceId !== "") {
      obj.priceId = message.priceId;
    }
    if (message.priceCents !== 0) {
      obj.priceCents = Math.round(message.priceCents);
    }
    return obj;
  },

  create(base?: DeepPartial<PriceInfo>): PriceInfo {
    return PriceInfo.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PriceInfo>): PriceInfo {
    const message = createBasePriceInfo();
    message.priceId = object.priceId ?? "";
    message.priceCents = object.priceCents ?? 0;
    return message;
  },
};

function createBaseSubscriptionDetails(): SubscriptionDetails {
  return { id: "", status: "", items: [], customerId: "" };
}

export const SubscriptionDetails: MessageFns<SubscriptionDetails> = {
  encode(message: SubscriptionDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.status !== "") {
      writer.uint32(18).string(message.status);
    }
    for (const v of message.items) {
      SubscriptionItem.encode(v!, writer.uint32(26).fork()).join();
    }
    if (message.customerId !== "") {
      writer.uint32(34).string(message.customerId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SubscriptionDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubscriptionDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.status = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.items.push(SubscriptionItem.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.customerId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SubscriptionDetails {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      status: isSet(object.status) ? globalThis.String(object.status) : "",
      items: globalThis.Array.isArray(object?.items) ? object.items.map((e: any) => SubscriptionItem.fromJSON(e)) : [],
      customerId: isSet(object.customerId)
        ? globalThis.String(object.customerId)
        : isSet(object.customer_id)
        ? globalThis.String(object.customer_id)
        : "",
    };
  },

  toJSON(message: SubscriptionDetails): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.status !== "") {
      obj.status = message.status;
    }
    if (message.items?.length) {
      obj.items = message.items.map((e) => SubscriptionItem.toJSON(e));
    }
    if (message.customerId !== "") {
      obj.customerId = message.customerId;
    }
    return obj;
  },

  create(base?: DeepPartial<SubscriptionDetails>): SubscriptionDetails {
    return SubscriptionDetails.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SubscriptionDetails>): SubscriptionDetails {
    const message = createBaseSubscriptionDetails();
    message.id = object.id ?? "";
    message.status = object.status ?? "";
    message.items = object.items?.map((e) => SubscriptionItem.fromPartial(e)) || [];
    message.customerId = object.customerId ?? "";
    return message;
  },
};

function createBaseSubscriptionItem(): SubscriptionItem {
  return { id: "", priceId: "" };
}

export const SubscriptionItem: MessageFns<SubscriptionItem> = {
  encode(message: SubscriptionItem, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.priceId !== "") {
      writer.uint32(18).string(message.priceId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SubscriptionItem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubscriptionItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.priceId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SubscriptionItem {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      priceId: isSet(object.priceId)
        ? globalThis.String(object.priceId)
        : isSet(object.price_id)
        ? globalThis.String(object.price_id)
        : "",
    };
  },

  toJSON(message: SubscriptionItem): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.priceId !== "") {
      obj.priceId = message.priceId;
    }
    return obj;
  },

  create(base?: DeepPartial<SubscriptionItem>): SubscriptionItem {
    return SubscriptionItem.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SubscriptionItem>): SubscriptionItem {
    const message = createBaseSubscriptionItem();
    message.id = object.id ?? "";
    message.priceId = object.priceId ?? "";
    return message;
  },
};

function createBaseEnterpriseSubscriptionDetails(): EnterpriseSubscriptionDetails {
  return { orgId: "", tierId: "", subscription: undefined };
}

export const EnterpriseSubscriptionDetails: MessageFns<EnterpriseSubscriptionDetails> = {
  encode(message: EnterpriseSubscriptionDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.tierId !== "") {
      writer.uint32(18).string(message.tierId);
    }
    if (message.subscription !== undefined) {
      SubscriptionDetails.encode(message.subscription, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EnterpriseSubscriptionDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEnterpriseSubscriptionDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tierId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.subscription = SubscriptionDetails.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EnterpriseSubscriptionDetails {
    return {
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      tierId: isSet(object.tierId)
        ? globalThis.String(object.tierId)
        : isSet(object.tier_id)
        ? globalThis.String(object.tier_id)
        : "",
      subscription: isSet(object.subscription) ? SubscriptionDetails.fromJSON(object.subscription) : undefined,
    };
  },

  toJSON(message: EnterpriseSubscriptionDetails): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.tierId !== "") {
      obj.tierId = message.tierId;
    }
    if (message.subscription !== undefined) {
      obj.subscription = SubscriptionDetails.toJSON(message.subscription);
    }
    return obj;
  },

  create(base?: DeepPartial<EnterpriseSubscriptionDetails>): EnterpriseSubscriptionDetails {
    return EnterpriseSubscriptionDetails.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<EnterpriseSubscriptionDetails>): EnterpriseSubscriptionDetails {
    const message = createBaseEnterpriseSubscriptionDetails();
    message.orgId = object.orgId ?? "";
    message.tierId = object.tierId ?? "";
    message.subscription = (object.subscription !== undefined && object.subscription !== null)
      ? SubscriptionDetails.fromPartial(object.subscription)
      : undefined;
    return message;
  },
};

function createBaseCreditsPricing(): CreditsPricing {
  return { pricing: [] };
}

export const CreditsPricing: MessageFns<CreditsPricing> = {
  encode(message: CreditsPricing, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.pricing) {
      EventCreditsPrice.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreditsPricing {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreditsPricing();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pricing.push(EventCreditsPrice.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreditsPricing {
    return {
      pricing: globalThis.Array.isArray(object?.pricing)
        ? object.pricing.map((e: any) => EventCreditsPrice.fromJSON(e))
        : [],
    };
  },

  toJSON(message: CreditsPricing): unknown {
    const obj: any = {};
    if (message.pricing?.length) {
      obj.pricing = message.pricing.map((e) => EventCreditsPrice.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<CreditsPricing>): CreditsPricing {
    return CreditsPricing.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreditsPricing>): CreditsPricing {
    const message = createBaseCreditsPricing();
    message.pricing = object.pricing?.map((e) => EventCreditsPrice.fromPartial(e)) || [];
    return message;
  },
};

function createBaseEventCreditsPrice(): EventCreditsPrice {
  return { eventType: 0, creditsPerEvent: 0 };
}

export const EventCreditsPrice: MessageFns<EventCreditsPrice> = {
  encode(message: EventCreditsPrice, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.eventType !== 0) {
      writer.uint32(8).int32(message.eventType);
    }
    if (message.creditsPerEvent !== 0) {
      writer.uint32(16).int32(message.creditsPerEvent);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EventCreditsPrice {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEventCreditsPrice();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.eventType = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.creditsPerEvent = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EventCreditsPrice {
    return {
      eventType: isSet(object.eventType)
        ? meteredEventTypeFromJSON(object.eventType)
        : isSet(object.event_type)
        ? meteredEventTypeFromJSON(object.event_type)
        : 0,
      creditsPerEvent: isSet(object.creditsPerEvent)
        ? globalThis.Number(object.creditsPerEvent)
        : isSet(object.credits_per_event)
        ? globalThis.Number(object.credits_per_event)
        : 0,
    };
  },

  toJSON(message: EventCreditsPrice): unknown {
    const obj: any = {};
    if (message.eventType !== 0) {
      obj.eventType = meteredEventTypeToJSON(message.eventType);
    }
    if (message.creditsPerEvent !== 0) {
      obj.creditsPerEvent = Math.round(message.creditsPerEvent);
    }
    return obj;
  },

  create(base?: DeepPartial<EventCreditsPrice>): EventCreditsPrice {
    return EventCreditsPrice.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<EventCreditsPrice>): EventCreditsPrice {
    const message = createBaseEventCreditsPrice();
    message.eventType = object.eventType ?? 0;
    message.creditsPerEvent = object.creditsPerEvent ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
